import './src/global.less';

// Der Chatbot wird beim Seitenaufruf mit dem API-Key der jeweiligen Sprache
// geladen. Wechselt die Sprache per Client-Navigation (z.B. Sprachumschalter),
// laden wir die Seite neu, damit der passende Chatbot initialisiert wird.
const reloadOnChatbotLanguageChange = (location) => {
  const container = document.getElementById('chatbot-container');
  if (container == null || location == null) {
    return;
  }
  const language = location.pathname.startsWith('/de/') ? 'de' : 'en';
  const chatbotLanguage = container.getAttribute('data-omq-chatbot-language');
  if (chatbotLanguage != null && chatbotLanguage !== language) {
    window.location.reload();
  }
};

export const onRouteUpdate = ({ location }) => {
  reloadOnChatbotLanguageChange(location);
  if (window.posthog) {
    window.posthog.capture('$pageview');
  }
};

// Gatsby has a bug where location is passed as prevLocation and prevLocation as next location
export const onPreRouteUpdate = ({ location }) => {
  if (window.posthog) {
    window.posthog.capture('$pageleave', {
      $current_url: location.origin + location.pathname,
      $pathname: location.pathname,
      $set: {
        $current_url: location.origin + location.pathname,
        $pathname: location.pathname,
      },
      $set_once: {
        $current_url: location.origin + location.pathname,
        $pathname: location.pathname,
      },
    });
  }
};
